import i18n from "../../../../i18n";
const AlertName = i18n.t('manageAutomation.AlertName');
const State = i18n.t('manageAutomation.State');
const SupportGroup = i18n.t('manageAutomation.SupportGroup');
const URL = i18n.t('manageAutomation.Url');
const InstanceName = i18n.t('manageAutomation.InstanceName');
const SourceProvider = i18n.t('manageAutomation.SourceProvider');
const InstanceStatus = i18n.t('manageAutomation.InstanceStatus');
const SourceType = i18n.t('manageAutomation.SourceType');

const INFRA_INFORMATIONAL_HEADERS = [

    {
        key: 'alertName',
        header: AlertName,
        hidden: false,
        optional: false
    },
    {
        key: 'state',
        header: State,
        hidden: false,
        optional: false
    },
    {
        key: 'supportGroup',
        header: SupportGroup,
        hidden: false,
        optional: false
    },
    {
        key: 'url',
        header: URL,
        hidden: false,
        optional: false
    },
    {
        key: 'instanceName',
        header: InstanceName,
        hidden: false,
        optional: false
    },
    {
        key: 'sourceProvider',
        header: SourceProvider,
        hidden: false,
        optional: false
    },
    {
        key: 'instanceStatus',
        header: InstanceStatus,
        hidden: true,
        optional: true
    },
    {
        key: 'sourceType',
        header: SourceType,
        hidden: true,
        optional: true
    }
];
export default INFRA_INFORMATIONAL_HEADERS;